import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { AppRouter } from './App';
render(<AppRouter data-id="element-23084" />, document.getElementById('root'));